export namespace Styles {
  export const Dialog = {
    breakpoints: { '576px': '99vw' },
    style: { 'width': '850px' },
  }
}